import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: spacing(34, 45, 34, 34),
    width: 'auto',
    gap: spacing(24),
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: spacing(8),
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridGap: spacing(16),
    width: '100%',
  },
  fullRow: {
    display: 'flex',
    width: '100%',
  },
  input: {
    maxWidth: spacing(450),
    marginTop: spacing(16),
  },
}))
